import { OverlayPositionBuilder } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from '@content-platform/web-angular-shared-util-pipes';
import { MatLegacyAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyOptionModule, MatLegacyRippleModule } from '@angular/material/legacy-core';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MAT_LEGACY_TOOLTIP_DEFAULT_OPTIONS, MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import { RouterModule } from '@angular/router';
import { WebAngularSharedDataAccessApplicationApiModule, PermissionsModule } from '@content-platform/web-angular-shared-data-access-application-api';
import { AuthModule } from '@content-platform/web-angular-shared-util-auth';
import { DevelopmentModule } from '@content-platform/web-angular-shared-util-development';
import { LoggingModule } from '@content-platform/web-angular-shared-util-logging';
import { FooterComponent } from './footer/footer.component';
import { NavBarComponent } from './header/nav-bar/nav-bar.component';
import { UserMenuComponent } from './header/user-menu/user-menu.component';
import { NotPropertyPipe } from './not-property.pipe';
import { SidenavMenuItemComponent } from './sidenav-menu-item/sidenav-menu-item.component';
import { ExtendedPositionBuilder } from './sidenav/sidenav-menu-position-strategy';
import { SideNavComponent } from './sidenav/sidenav.component';
import { ContentHeaderBarComponent } from './header/content-header-bar/content-header-bar.component';
import { ContentHeaderBarService } from './header/content-header-bar/content-header-bar.service';
import { NAVIGATION_OPTIONS } from './navigation-options';
import { ContentHeaderButtonComponent } from './header/content-header-button/content-header-button.component';
import { ReusableUiFeatureFlagsModule } from '@content-platform/reusable-ui/feature-flags';
import { Configuration } from '@content-platform/web-angular-shared-util-configuration';
import { MdePopoverModule } from '@niewicz/mde-popover';
import { AdditionalPartnerInfoPopupComponent } from './header/additional-partner-info-popup/additional-partner-info-popup.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/icon";
export const customTooltipDefaults = {
    showDelay: 1000,
    hideDelay: 500,
    touchendHideDelay: 500
};
export function optionsFactory() {
    return {
        production: Configuration.isProductionEquivalentEnvironment()
    };
}
export class NavigationModule {
    constructor(matIconRegistry) {
        this.matIconRegistry = matIconRegistry;
        matIconRegistry.registerFontClassAlias('fontawesome', 'fa');
    }
    static forRoot() {
        return {
            ngModule: NavigationModule,
            providers: [{ provide: NAVIGATION_OPTIONS, useFactory: optionsFactory }]
        };
    }
    static { this.ɵfac = function NavigationModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NavigationModule)(i0.ɵɵinject(i1.MatIconRegistry)); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: NavigationModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            ContentHeaderBarService,
            { provide: MAT_LEGACY_TOOLTIP_DEFAULT_OPTIONS, useValue: customTooltipDefaults },
            { provide: OverlayPositionBuilder, useClass: ExtendedPositionBuilder }
        ], imports: [CommonModule,
            FormsModule,
            PipesModule,
            ReactiveFormsModule,
            RouterModule,
            MatLegacyListModule,
            MatIconModule,
            AuthModule,
            WebAngularSharedDataAccessApplicationApiModule,
            MatToolbarModule,
            MatLegacyButtonModule,
            MatLegacyInputModule,
            MatLegacyMenuModule,
            MatLegacyAutocompleteModule,
            MatGridListModule,
            MatSidenavModule,
            MatLegacyCheckboxModule,
            MatLegacyTooltipModule,
            MatLegacyRippleModule,
            MatExpansionModule,
            DevelopmentModule,
            LoggingModule,
            MatLegacyDialogModule,
            MatLegacyCardModule,
            MatLegacySelectModule,
            MatLegacyOptionModule,
            PermissionsModule,
            ReusableUiFeatureFlagsModule,
            MdePopoverModule] }); }
}
//# sourceMappingURL=navigation.module.js.map